import PageTemplate from "../../templates/Template";

// DashboardPage for finance
export const DashboardPage = (props) => {
  return (
    <PageTemplate title="Dashboard" menu="dashboard" isDrawerOpen={props.isDrawerOpen} setIsDrawerOpen={props.setIsDrawerOpen}>
      <p>This is the main dashboard for finance</p>
    </PageTemplate>
  )
};